import { render, staticRenderFns } from "./ChainingAddServices.vue?vue&type=template&id=3fb58ce3"
import script from "./ChainingAddServices.ts?vue&type=script&lang=ts&external"
export * from "./ChainingAddServices.ts?vue&type=script&lang=ts&external"
import style0 from "./ChainingAddServices.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports